const listeners = []

const notify = ({ text, type = 'success' }) => {
  listeners.forEach(listener => listener({ text, type }))
}

const subscribeToToasts = (listener) => {
  listeners.push(listener)
  return () => {
    const index = listeners.indexOf(listener)
    if (index !== -1) listeners.splice(index, 1)
  }
}

export { notify, subscribeToToasts }
